module.exports = __webpack_public_path__ + "static/image/main/m/banner-8.ver2_0_2.jpg?1ff5a796";